export const parseCoordinate = (coordinate, type) => {
    switch (type) {
      case "Time":
        return new Date(coordinate * 1000)
      default:
        return coordinate
    }
  }
